var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMagnifer = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.58317 2.29199C5.55609 2.29199 2.2915 5.55658 2.2915 9.58366C2.2915 13.6107 5.55609 16.8753 9.58317 16.8753C13.6102 16.8753 16.8748 13.6107 16.8748 9.58366C16.8748 5.55658 13.6102 2.29199 9.58317 2.29199ZM1.0415 9.58366C1.0415 4.86623 4.86574 1.04199 9.58317 1.04199C14.3006 1.04199 18.1248 4.86623 18.1248 9.58366C18.1248 11.7174 17.3424 13.6684 16.0489 15.1655L18.7751 17.8917C19.0192 18.1358 19.0192 18.5315 18.7751 18.7756C18.531 19.0197 18.1353 19.0197 17.8912 18.7756L15.165 16.0494C13.668 17.3429 11.7169 18.1253 9.58317 18.1253C4.86574 18.1253 1.0415 14.3011 1.0415 9.58366Z"
})));
export default SvgMagnifer;